<template>
  <header class="app-header">
    <button
      v-if="!hideBack"
      class="app-header__back"
      type="button"
      aria-label="뒤로"
      @click="handleBack"
    >
      <img class="app-header__back-icon" :src="headerAsset('arrow-left.svg')" alt="" />
    </button>
    <span>{{ title }}</span>
    <button v-if="actionLabel" class="app-header__action" type="button" @click="handleAction">
      {{ actionLabel }}
    </button>
  </header>
</template>

<script setup>
const props = defineProps({
  title: { type: String, default: "" },
  backTo: { type: String, default: "" },
  actionLabel: { type: String, default: "" },
  hideBack: { type: Boolean, default: false },
  interceptBack: { type: Boolean, default: false },
});

const emit = defineEmits(["action", "back"]);

const router = useRouter();
const route = useRoute();

const headerAsset = (file) => {
  const base = useRuntimeConfig().app.baseURL || "/view";
  return `${String(base).replace(/\/$/, "")}/assets/images/${file}`;
};

const homePath = () => (isGuestPath(route.path) ? "/guest" : "/main");

const backPath = () => {
  if (!import.meta.client) return "";
  const back = window.history.state?.back;
  if (!back) return "";
  return typeof back === "string" ? back : back.fullPath || back.path || "";
};

const handleBack = () => {
  if (props.interceptBack) {
    emit("back");
    return;
  }
  // 단말보호 아래 화면은 단말보호 메인으로 돌아간다. 홈에서 바로 연 경우만 홈으로 간다.
  // 비상연락처 등록·편집과 발송내역은 연락처 목록으로 돌아간다. 안드로이드 백키도 같은 규칙을 쓴다.
  if (isTabRootPath(route.path)) {
    navigateTo("/main", { replace: true });
    return;
  }
  if (isDeviceChildPath(route.path)) {
    if (isEmergencyFormRoute(route)) {
      if (backPath()) {
        router.back();
        return;
      }
      navigateTo("/device/emergency-contact", { replace: true });
      return;
    }
    if (isMessageHistoryPath(route.path)) {
      if (isEmergencyContactPath(backPath())) {
        router.back();
        return;
      }
      navigateTo("/device/emergency-contact", { replace: true });
      return;
    }
    if (isHomePath(backPath())) {
      router.back();
      return;
    }
    exitDeviceSection();
    return;
  }
  const prev = backPath();
  const onGuest = isGuestPath(route.path);
  if (prev && isGuestPath(prev) === onGuest) {
    router.back();
    return;
  }
  if (props.backTo) {
    navigateTo(props.backTo);
    return;
  }
  navigateTo(homePath());
};

const handleAction = () => {
  emit("action");
};
</script>
